module.exports = __webpack_public_path__ + "img/doc-outline.b38135bc.svg";